// extracted by mini-css-extract-plugin
module.exports = {"root":"VacancyForm_root__2XmjJ","icon":"VacancyForm_icon__1vG1W","heading":"VacancyForm_heading__1wtk-","field":"VacancyForm_field__2vUzH","error":"VacancyForm_error__3wGnF"};